(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["grenn-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('grenn-size-guide')) {
  customElements.define('grenn-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelectorAll('[data-unit]').forEach(button => button.addEventListener('click', () => {
        this.querySelectorAll('[data-unit]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        this.querySelectorAll('[data-cm]').forEach(cell => {
          cell.textContent = button.dataset.unit === 'cm' ? cell.dataset.cm : new Intl.NumberFormat(document.documentElement.lang || 'en', {maximumFractionDigits:2}).format(Number(cell.dataset.cm) / 2.54);
        });
      }));
      const tabs = Array.from(this.querySelectorAll('[role=tab]'));
      const select = tab => {
        tabs.forEach(t => {t.setAttribute('aria-selected', String(t === tab));t.tabIndex = t === tab ? 0 : -1;});
        this.querySelectorAll('[data-panel-content]').forEach(panel => {panel.hidden = panel.dataset.panelContent !== tab.dataset.panel;});
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const next = tabs[event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          select(next);next.focus();
        });
      });
      this.onSizeChange = () => this.highlightSize();
      this.productInfo = this.closest('product-info');
      this.productInfo?.addEventListener('change', this.onSizeChange);
      this.closest('details').addEventListener('toggle', this.onSizeChange);
      this.highlightSize();
    }
    highlightSize() {
      const picker = this.closest('product-info')?.querySelector('variant-selects');
      const size = picker?.querySelector('input[type=radio]:checked')?.value || picker?.querySelector('select')?.value || this.dataset.currentSize;
      this.querySelectorAll('[data-size]').forEach(cell => cell.toggleAttribute('data-current', cell.dataset.size === size));
    }
    disconnectedCallback() {
      this.productInfo?.removeEventListener('change', this.onSizeChange);
      this.closest('details')?.removeEventListener('toggle', this.onSizeChange);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
